/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import {useAppDispatch, useAppSelector} from "../store";
import {Button, Drawer, Space, Spin, Tabs} from "antd";
import React, {useEffect, useState} from "react";
import {closeDrawer} from "../reducers/drawers-reducer";
import {get, upload, uploadDrop, uploadSend} from "../core/request";
import {ViewState} from "../states";
import Dragger from "antd/es/upload/Dragger";
import {InboxOutlined, StopOutlined, WarningTwoTone} from "@ant-design/icons";
import ManualEntryForm from "../components/manualEntry";


interface DrawerProps {
    size?: 'default' | 'large'
}

export function UploadDrawer(props: DrawerProps) {
    const stack = useAppSelector((state: any) => state.drawer.upload)
    const dispatch = useAppDispatch();

    const [deviceId, setDeviceId] = useState(undefined);
    const [state, setState] = useState(ViewState.loading);
    const [uploads, setUploads] = useState({
        tabs: [
            {
                title: "Monatsbericht",
                draggers: [
                    {
                        title: "",
                        desc: "",
                        accept: null,
                        filename: "file"
                    },
                ]
            }
        ]
    });
    var data = new FormData();

    useEffect(() => {
        if (stack.length > 0) {
            var deviceId = stack[stack.length - 1]
            setDeviceId(deviceId)
            setState(ViewState.loading);
            get("devices/" + deviceId + "/upload").then(
                (response) => {
                    console.log(response.data.uploads)
                    setUploads(response.data.uploads);
                    data = new FormData();
                    setState(ViewState.success);
                },
                (e) => {
                    setState(ViewState.failed);
                }
            )
        } else {
            setDeviceId(undefined)
        }

    }, [stack])

    const drawer_body = () => {
        let items = uploads?.tabs?.map((tab, index) => {
            console.log("tab", index, tab);
            return (
                {
                    key: index as unknown as string,
                    label: tab.title,
                    children: create_draggers(tab.draggers)
                }
            )
        })
        console.log("items", items);

        /*
        // manual entry moved to the report creation workflow. No longer needed here.
        items?.push({
            key: "manual",
            label: "manuelle Eingabe",
            children: (<ManualEntryForm deviceId={deviceId}/>)
        })
        */

        return (
            <Tabs
                defaultActiveKey="0"
                // @ts-ignore
                items={items}
            >
            </Tabs>)
    }


    const create_draggers = (draggers: any) => {
        switch (state) {
            case ViewState.loading:
                return (
                    <Dragger disabled>
                        <p className="ant-upload-drag-icon">
                            <Spin spinning/>
                        </p>
                        <p className="ant-upload-text">Upload wird vorbereitet...</p>
                    </Dragger>
                )
            case ViewState.success:
                return (
                    <Space direction="vertical" style={{width: '100%'}} size={12}>
                        {
                            draggers.map((dragger: any, index: any) => {
                                console.log("dragger", dragger, dragger.filename);
                                return (
                                    <Dragger
                                        height={
                                            draggers.length > 1 ?
                                                (window.innerHeight - 175 - 69) / draggers.length - 34 :
                                                window.innerHeight - 175
                                        }
                                        containerStyle={{verticalAlign: 'middle'}}
                                        customRequest={draggers.length > 1 ? uploadDrop : upload}
                                        maxCount={1}
                                        action={"devices/" + deviceId + "/upload"}
                                        // @ts-ignore
                                        data={data}
                                        name={dragger.filename}
                                        accept={dragger.accept}
                                        disabled={!(!!dragger.accept)}
                                        onChange={(props) => {
                                            if (props.file.status === 'done') {
                                                dispatch(closeDrawer('upload'));
                                            }
                                        }}
                                    >
                                        <p className="ant-upload-drag-icon">
                                            {
                                                // @ts-ignore
                                                !!dragger.accept ? (<InboxOutlined/>) : (<StopOutlined/>)
                                            }
                                        </p>
                                        <p className="ant-upload-text">{
                                            // @ts-ignore
                                            dragger.title
                                        }</p>
                                        <p className="ant-upload-hint">{
                                            // @ts-ignore
                                            dragger.desc
                                        }</p>
                                    </Dragger>
                                )
                            })
                        }
                        {
                            draggers.length > 1 ? (
                                <Button type="primary" onClick={() => {
                                    uploadSend({
                                        action: "devices/" + deviceId + "/upload",
                                        data: data,
                                        onSuccess: () => {
                                            dispatch(closeDrawer('upload'));
                                        },
                                    })
                                }}>Hochladen</Button>
                            ) : (<> </>)
                        }
                    </Space>
                )

            default:
            case ViewState.failed:
                return (
                    <Dragger disabled>
                        <p className="ant-upload-drag-icon">
                            <WarningTwoTone style={{fontSize: 48, paddingTop: 48}} twoToneColor='#ffc107'/>
                        </p>
                        <p className="ant-upload-text">Fehler!</p>
                        <p className="ant-upload-hint">Der Upload konnte nicht vorbereitet werden.</p>
                    </Dragger>

                )
        }
    }

    return (
        <Drawer
            open={stack.length > 0}
            size={props.size}
            onClose={() => dispatch(closeDrawer('upload'))}
            forceRender={true}
            zIndex={1001} // always on top
            bodyStyle={{paddingTop: 0, paddingBottom: 0}}
            title={
                <Space direction="horizontal" style={{width: '100%', justifyContent: 'center'}}>
                    <h1 style={{marginBottom: 0}}>Datenimport</h1>
                </Space>
            }
        >
            {drawer_body()}
        </Drawer>
    )
}


UploadDrawer.defaultProps = {
    size: 'large'
}